import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";

export function useRequestTemplateAccess(onDone = () => {}) {
  const mutationFactory = useCallback(() => {
    const query = `mutation requestAccessToTemplate($templateReleaseId: ID!) {
        requestTemplatePermission(templateReleaseId: $templateReleaseId) {
            updatedStatus
            successMessage
        }
    }`;

    const resolver = ({ errors, data }) => {
      if (errors && errors.length) {
        return { errors: errors };
      }

      const { updatedStatus } = data.requestTemplatePermission;
      return {
        data: {
          updatedStatus: updatedStatus,
        },
      };
    };

    return { query, resolver };
  }, []);

  const [request, { loading }] = useMutationWithToaster(mutationFactory, {
    onDone: useCallback(onDone, []),
  });

  return { request: request, requesting: loading };
}

export default useRequestTemplateAccess;
